import { useEffect, useState } from 'react'
import { KEYBOARD_KEY, DOM_EVENT } from '@/shared/constants/keyboard'

export function useMobileMenu() {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === KEYBOARD_KEY.ESCAPE) setIsOpen(false)
    }
    document.addEventListener(DOM_EVENT.KEYDOWN, handleKeyDown)
    return () => document.removeEventListener(DOM_EVENT.KEYDOWN, handleKeyDown)
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [isOpen])

  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }

  return { isOpen, open, close }
}
